import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { store, persistor } from './store.js';

// import components

import HomePage from './HomePage/homepage'
import Faq from './FAQ/faq'
import LandingHome from './LandingHome/landinghome'
import Profile from './Profile/profile';
import StripeConfirmation from './Profile/StripeConfirmation';
import Settings from './Settings/settings'
import Signup from './Signup/wizardform'
import Calendar from './Calendar/calendar'
import ClientProfile from './ClientProfile/ClientProfile'

import Team from './Team/team'
import Fidelity from './Fidelity/fidelity'
import Chat from './Chat/chat'
import Payment from './Payment/payment'
import ForgotPassword from './ForgotPassword/ForgotPassword.js'
import Purchase from './Purchase/purchase.js'

//css
import "./style.less";
import "./index.js"


/**** Parse ****/

import { Parse } from "parse";
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

/***** Production *****/

Parse.serverURL = "https://urbanfitnessfrance.herokuapp.com/parse";

/****** Development ****/

//Parse.serverURL = "http://10.2.1.167:3000/parse"

// Tremplin Antoine
//Parse.serverURL = "http://192.168.5.38:4000/parse";

// Partage de connexion
//Parse.serverURL = "http://192.168.43.190:4000/parse";


//DODDY'S
//Parse.serverURL = "http://192.168.0.35:3000/parse"

const router = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={HomePage}/>
          <Route path="/aide" component={Faq} />
          <Route path="/landing" component={LandingHome} />
          <Route path="/profile" component={Profile}/>
          <Route path="/client" component={ClientProfile}/>
          <Route path="/settings" component={Settings} />
          <Route path="/signup" component={Signup}/>
          <Route path="/agenda" component={Calendar} />
          <Route path="/team" component={Team} />
          <Route path="/fidelite" component={Fidelity} />
          <Route path="/chat" component={Chat} />
          <Route path="/purchase" component={Purchase} />
          <Route path="/payment" component={Payment} />
          <Route path="/confirmation" component={StripeConfirmation} />
          <Route path="/forgotpassword" component={ForgotPassword} />
        </Switch>
      </BrowserRouter>
    </PersistGate>
  </Provider>)

render(router, document.getElementById('root'));
